<script>
	export let label = 'Loading...';
</script>

<div class="flex my-auto">
	<div class="loading"></div>
	<div class="ml-4">{label}</div>
</div>
